import Vue from 'vue'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GET_USER_GUILDS: (context, { adminOnly }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/me/guilds?onlyAdmin=${adminOnly || false}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_COMMUNITY: (context, { community }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post('/v1/communities', community)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_COMMUNITY: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${communityId}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_COMMUNITY: (context, { communityId, community }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(`/v1/communities/${communityId}`, community)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_COMMUNITY: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(`/v1/communities/${communityId}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_COMMUNITY_DISCORD: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${communityId}/guild`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_COMMUNITY_SERVICES: (
      context,
      { communityId, pageNumber = 1, pageSize = 10, search = '', onlyActive = true },
    ) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${communityId}/services?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}&onlyActive=${onlyActive}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_COMMUNITY_SERVICE: (context, { communityId, serviceId, data }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(`/v1/communities/${communityId}/services/${serviceId}/settings`, data)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_BOT_GUILD: (context, { guildId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/bot/guilds/${guildId}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_BOT_GUILD_CHANNELS: (context, { guildId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/bot/guilds/${guildId}/channels`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_BOT_GUILD_ROLES: (context, { guildId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/bot/guilds/${guildId}/roles`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_SERVICE: (context, { communityId, service }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/services`, service)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FINALIZE_SUBSCRIPTION: (context, { communityId, subscriptionId, serviceIds }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/subscription/finalize`, { subscriptionId, serviceIds })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_COMMUNITY_SUBSCRIPTION: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${communityId}/subscription`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_COMMUNITY_SUBSCRIPTION: (context, { communityId, services, isPreview = true }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(`/v1/communities/${communityId}/subscription`, { services, isPreview })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    PAUSE_COMMUNITY_SUBSCRIPTION: (context, { communityId, pause }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/subscription/pause`, { pause })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CANCEL_COMMUNITY_SUBSCRIPTION: (context, { communityId, cancelReason, cancelReasonDetails }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/subscription/cancel`, {
            cancelReason,
            cancelReasonDetails,
          })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_SUBSCRIPTION_TRANSACTIONS: (context, { communityId, startDate, endDate, pageNumber, pageSize }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${communityId}/subscription/transactions?startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_SERVICE_FROM_TRANSFER_CODE: (context, { transferCode }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/service-from-transfer-code/${transferCode}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    TRANSFER_SERVICE: (context, { communityId, code, serviceId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/transfer-service`, { code, serviceId })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_DATABASE_CONFIG: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${communityId}/database`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    TEST_DATABASE_CONFIG: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/test-connection`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_REMOTE_DATABASE_TABLES: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/get-tables`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_REMOTE_DATABASE_TABLE_COLUMNS: (context, { communityId, databaseConfig, tableName }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/get-tables/${tableName}/columns`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_REMOTE_DATABASE_TABLE_COLUMN_FIELDS: (context, { communityId, databaseConfig, tableName, column }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/get-tables/${tableName}/columns/${column}`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    TEST_REMOTE_CITIZEN_MAPPING: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/test-mapping/citizen`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    TEST_REMOTE_VEHICLE_MAPPING: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/test-mapping/vehicle`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    TEST_REMOTE_LICENSE_MAPPING: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/remote/test-mapping/license`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_DATABASE_CONFIG: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/database`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_DATABASE_CONFIG: (context, { communityId, databaseConfig }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(`/v1/communities/${communityId}/database`, databaseConfig)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_DATABASE_CONFIG: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(`/v1/communities/${communityId}/database`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_CITIZEN_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/database/mappings/citizen`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_CITIZEN_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(`/v1/communities/${communityId}/database/mappings/citizen`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_VEHICLE_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/database/mappings/vehicle`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_VEHICLE_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(`/v1/communities/${communityId}/database/mappings/vehicle`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_LICENSE_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/database/mappings/license`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_LICENSE_MAPPING: (context, { communityId, mapping }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(`/v1/communities/${communityId}/database/mappings/license`, mapping)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_LICENSE_VALUES: (context, { communityId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${communityId}/license-values`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_LICENSE_VALUES: (context, { communityId, values }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/license-values/bulk`, values)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CREATE_LICENSE_VALUE: (context, { communityId, license }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/v1/communities/${communityId}/license-values`, license)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_LICENSE_VALUE: (context, { communityId, licenseValueId, license }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(`/v1/communities/${communityId}/license-values/${licenseValueId}`, license)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_LICENSE_VALUE: (context, { communityId, licenseValueId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(`/v1/communities/${communityId}/license-values/${licenseValueId}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
  },
}
